const API_BASE_URL = 'https://snapnotes-backend.onrender.com';

export default API_BASE_URL;